import { AnimatePresence, motion } from "motion/react";

interface BlockPresenceTransitionProps {
    children: React.ReactNode;
    isVisible: boolean;
    disableInitial?: boolean;
}

export function BlockPresenceTransition({
    children,
    isVisible,
    disableInitial,
}: BlockPresenceTransitionProps) {
    return (
        <AnimatePresence initial={disableInitial ? false : undefined}>
            {isVisible && (
                <motion.div
                    initial={{
                        opacity: 0,
                        scale: 0.7,
                        filter: "blur(24px)",
                    }}
                    animate={{
                        opacity: 1,
                        scale: 1,
                        filter: "blur(0px)",
                    }}
                    exit={{
                        opacity: 0,
                        scale: 0.7,
                        filter: "blur(24px)",
                    }}
                    transition={{
                        duration: 0.3,
                        ease: [0.25, 0.1, 0.25, 1],
                    }}
                >
                    {children}
                </motion.div>
            )}
        </AnimatePresence>
    );
}
